export const searchSesothoPlaceholder = "Kenya lentsoe ho batla";
export const searchEnglishPlaceholder = "Enter a word to search";
export const isUnsatisfactoryTooltipText = "Tlhaloso ya ketsahalo, lentsoe kapa lebitso ha e kgotsofatse ka botlalo ho ya ka dipatlisiso; kapa hona le ditlhaloso tse qhoebeshanang ho tsoa ho beng ba puo ya Sesotho kapa diphetolelong tseding tsa dibuka/maphetla a Basotho.";
export const englishSearchLanguageText = "Search in English";
export const sesothoSearchLanguageText = "Batla ka Sesotho";
export const sesothoNoResultsText = "Ha ho liphetho";
export const englishNoResultsText = "No results";